module.exports = __webpack_public_path__ + "img/maarga.61fdb06e.png";